module.exports = __webpack_public_path__ + "static/media/backup_03.e6b120d7.svg";